import React from 'react'
import Icon from '../res/icons'

const LinkItem = (props) => {
    const { to, icon } = props
    return (
        <a href={to} key={to} target="_blank">
            <div className="menu-link">
                <div className="menu-icon">
                    <Icon name={icon} height={'24px'} />
                </div>
                <div className="menu-title">
                    {props.children}
                </div>
            </div>
        </a>
    );
}

export default LinkItem;